import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { registerUser } from '../../../react-cognito';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import { createFormula, showCal, updateCalculator } from '../../../actions/addTreatments'

const $ = window.$;
const initialState = {
    treatmentName: '',
    calculationType: 'Dosage',
    dosageMl: '',
    dosageLb: '',
    minDuration: '',
    maxDuration: '',
    loading: false,
    calcData: {},
    edit: false,
}

class ViewFormula extends React.Component {
    constructor(props) {
        super(props);
    }
    
    state = initialState;

    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    resetState = () => {
        this.setState(initialState);
        // this.props.showCal(this.props.calcId);
    }

    closeModal = () => {
        $('#view_formula').modal('hide');
        this.resetState();
    }

    saveDosage = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        const data = {
            PetShopId: this.props.petShop.currentPetshop.id,
            dosageMl: this.state.dosageMl,
            dosageLb: this.state.dosageLb,
            minDuration: this.state.minDuration,
            maxDuration: this.state.maxDuration
        }

        if (data.dosageMl && data.dosageLb && data.minDuration && data.maxDuration) {
            this.props.updateCalculator(this.state.calcData.id, data);

        } else {
            NotificationManager.warning('Incomplete information.');
            this.setState({ loading: false });
        }
    }

    saveTablet = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        const data = {
            PetShopId: this.props.petShop.currentPetshop.id,
            strengthMg: this.state.strengthMg,
            doseType: this.state.doseType,
            doseMg: this.state.doseMg,
            doseTimes: this.state.doseTimes,
            minDuration: this.state.minDuration,
            maxDuration: this.state.maxDuration,
        }

        if (data.strengthMg && data.doseMg && data.doseTimes && data.minDuration && data.maxDuration && data.doseType) {
            this.props.updateCalculator(this.state.calcData.id, data);
        } else {
            NotificationManager.warning('Incomplete information.');
            this.setState({ loading: false });
        }
    }

    saveFormula = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        const data = {
            PetShopId: this.props.petShop.currentPetshop.id,
            strengthMg: this.state.strengthMg,
            strengthMl: this.state.strengthMl,
            doseMg: this.state.doseMg,
            doseLb: this.state.doseLb,
            doseTimes: this.state.doseTimes,
            minDuration: this.state.minDuration,
            maxDuration: this.state.maxDuration,
        }

        if (data.strengthMg && data.strengthMl && data.doseLb && data.doseMg && data.doseTimes && data.minDuration && data.maxDuration) {
            this.props.updateCalculator(this.state.calcData.id, data);

        } else {
            NotificationManager.warning('Incomplete information.');
            this.setState({ loading: false });
        }
    }

    editDosage = () => {
        this.setState({
            edit: true,
            dosageMl: this.state.calcData.dosageMl,
            dosageLb: this.state.calcData.dosageLb,
            minDuration: this.state.calcData.minDuration,
            maxDuration: this.state.calcData.maxDuration,
        });
    }

    editFormula = () => {
        this.setState({
            edit: true,
            strengthMg: this.state.calcData.strengthMg,
            strengthMl: this.state.calcData.strengthMl,
            doseMg: this.state.calcData.doseMg,
            doseLb: this.state.calcData.doseLb,
            doseTimes: this.state.calcData.doseTimes,
            minDuration: this.state.calcData.minDuration,
            maxDuration: this.state.calcData.maxDuration
        });
    }

    editTablet = () => {
        this.setState({
            edit: true,
            strengthMg: this.state.calcData.strengthMg,
            doseMg: this.state.calcData.doseMg,
            doseType: this.state.calcData.doseType,
            doseTimes: this.state.calcData.doseTimes,
            minDuration: this.state.calcData.minDuration,
            maxDuration: this.state.calcData.maxDuration
        });
    }

    componentWillReceiveProps = (nextProps) => {

        if(this.props.calculator !== nextProps.calculator) {
            this.setState({calcData: nextProps.calculator});
        }

        if(this.props.updatedCalculator !== nextProps.updatedCalculator) {
            this.setState({loading: false, edit: false});
            this.props.showCal(this.props.calcId);
            NotificationManager.success("Updated Successfully");
        }
    
    }

    render() {
        const {treatmentName, dosageMl, dosageLb, strengthMg, strengthMl, doseMg, doseLb, doseType, doseTimes, minDuration, maxDuration, calcData, edit} = this.state;

        return (
            <div className="modal fade show" id="view_formula" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {this.props.calcType === 'Dosage' && 
                            <form onSubmit={this.saveDosage} className="m-form">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel" style={{alignSelf: 'center'}}>View Set Dosage Calculator</h5>
                                    <button type="button" onClick={() => this.editDosage()} className="btn btn-link btn-link-no-deco m-portlet__nav-link m-portlet__nav-link--icon" style={{'width': 'unset'}}>
                                        <i className="la la-edit"></i>
                                    </button>
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Caclulator Name:</label>
                                                <div className="col-lg-8">
                                                    { calcData.treatmentName }
                                                </div>
                                            </div>
                                            <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                                <h5>Use Set Dosage</h5>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Dosage Ratio:</label>
                                                {!edit ?
                                                    <div className="col-lg-8">
                                                        {calcData.dosageMl} ml/ {calcData.dosageLb} lb
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="dosageMl" value={dosageMl} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dosage ratio (ml)</span>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="dosageLb" value={dosageLb} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dosage ratio (lb)</span>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Duration:</label>
                                                
                                                    {!edit ? 
                                                        <div className="col-lg-8">
                                                            {calcData.minDuration} - {calcData.maxDuration} days
                                                        </div>
                                                        :
                                                        <React.Fragment>
                                                            <div className="col-lg-4">
                                                                <input type="number" name="minDuration" value={minDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                                <span className="m-form__help">Please enter minimum duration (days)</span>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <input type="number" name="maxDuration" value={maxDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                                <span className="m-form__help">Please enter maximum duration (days)</span>
                                                            </div>
                                                        </React.Fragment>
                                                        
                                                    }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {edit && 
                                    <div className="modal-footer">
                                        {this.state.loading == false ?
                                            <div>
                                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                                <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                            </div>
                                        :
                                            <div className="center-row">
                                                <Loader size={50} />
                                            </div>
                                        }
                                    </div>
                                }
                                
                            </form>
                        }
                        {this.props.calcType === 'Formula' && 
                            <form onSubmit={this.saveFormula} className="m-form">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel" style={{alignSelf: 'center'}}>View Set Formula Calculator</h5>
                                    {!edit && 
                                        <button type="button" onClick={() => this.editFormula()} className="btn btn-link btn-link-no-deco m-portlet__nav-link m-portlet__nav-link--icon" style={{'width': 'unset'}}>
                                            <i className="la la-edit"></i>
                                        </button>
                                    }
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Calculator Name:</label>
                                                <div className="col-lg-8">
                                                    {calcData.treatmentName}
                                                </div>
                                            </div>
                                            <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                                <h5>Use Formula for Usage</h5>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Strength:</label>
                                                {!edit ?
                                                    <div className="col-lg-8">
                                                        {calcData.strengthMg} mg/ {calcData.strengthMl} ml
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="strengthMg" value={strengthMg} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter strength (mg)</span>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="strengthMl" value={strengthMl} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter strength (ml)</span>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                                
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Dose:</label>
                                                {!edit ?
                                                    <div className="col-lg-8">
                                                        {calcData.doseMg} mg/ {calcData.doseLb} lb {calcData.doseTimes}x a day
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-3">
                                                            <input type="number" name="doseMg" value={doseMg} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dose (mg)</span>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <input type="number" name="doseLb" value={doseLb} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dose (lb)</span>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input type="number" name="doseTimes" value={doseTimes} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dose (x a day)</span>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Duration:</label>
                                                {!edit ? 
                                                    <div className="col-lg-8">
                                                        {calcData.minDuration} - {calcData.maxDuration} days
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="minDuration" value={minDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter minimum duration (days)</span>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="maxDuration" value={maxDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter maximum duration (days)</span>
                                                        </div>
                                                    </React.Fragment>
                                                    
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {edit && 
                                    <div className="modal-footer">
                                        {this.state.loading == false ?
                                            <div>
                                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                                <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                            </div>
                                        :
                                            <div className="center-row">
                                                <Loader size={50} />
                                            </div>
                                        }
                                    </div>
                                }
                                
                            </form>
                        }
                        {this.props.calcType === 'Tablet' && 
                            <form onSubmit={this.saveTablet} className="m-form">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel" style={{alignSelf: 'center'}}>View Set Tablet Calculator</h5>
                                    {!edit && 
                                        <button type="button" onClick={() => this.editTablet()} className="btn btn-link btn-link-no-deco m-portlet__nav-link m-portlet__nav-link--icon" style={{'width': 'unset'}}>
                                            <i className="la la-edit"></i>
                                        </button>
                                    }
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Calculator Name:</label>
                                                <div className="col-lg-8">
                                                    {calcData.treatmentName}
                                                </div>
                                            </div>
                                            <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                                <h5>Use Tablet for Usage</h5>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Strength:</label>
                                                {!edit ?
                                                    <div className="col-lg-8">
                                                        {calcData.strengthMg} mg/tab
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-8">
                                                            <input type="number" name="strengthMg" value={strengthMg} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter strength (mg/tab)</span>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                                
                                            </div>
                                            {edit &&
                                                <div className="form-group m-form__group row">
                                                    <label className="col-lg-4 col-form-label">Dose Type:</label>
                                                    <div className="col-lg-8">
                                                        <div className="m-radio-inline">
                                                            <label className="m-radio m-radio--solid m-radio--state-success">
                                                                <input type="radio" name="doseType" checked={doseType === "Lb"} onChange={this.changeVal} value="Lb" /> Lb
                                                                <span></span>
                                                            </label>
                                                            <label className="m-radio m-radio--solid m-radio--state-success">
                                                                <input type="radio" name="doseType" checked={doseType === "Kg"} onChange={this.changeVal} value="Kg" /> Kg
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Dose:</label>
                                                {!edit ?
                                                    <div className="col-lg-8">
                                                        {calcData.doseMg} mg/{(calcData.doseType === "Lb") ? "lb" : "kg"} {calcData.doseTimes}x a day
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="doseMg" value={doseMg} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dose (mg)</span>
                                                        </div>
                                                        
                                                        <div className="col-lg-4">
                                                            <input type="number" name="doseTimes" value={doseTimes} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter dose (x a day)</span>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-form-label">Duration:</label>
                                                {!edit ? 
                                                    <div className="col-lg-8">
                                                        {calcData.minDuration} - {calcData.maxDuration} days
                                                    </div>
                                                    :
                                                    <React.Fragment>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="minDuration" value={minDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter minimum duration (days)</span>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <input type="number" name="maxDuration" value={maxDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                            <span className="m-form__help">Please enter maximum duration (days)</span>
                                                        </div>
                                                    </React.Fragment>
                                                    
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {edit && 
                                    <div className="modal-footer">
                                        {this.state.loading == false ?
                                            <div>
                                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                                <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                            </div>
                                        :
                                            <div className="center-row">
                                                <Loader size={50} />
                                            </div>
                                        }
                                    </div>
                                }
                                
                            </form>
                        }
                    
                    </div>
                    
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    setCalculations: state.addFormulaReducer.setCalculations,
    calculator: state.addFormulaReducer.showCal,
    updatedCalculator: state.addFormulaReducer.updatedCalculator
});
  
const mapDispatchToProps = dispatch => ({
    createFormula: (attrs) => {
        dispatch(createFormula(attrs));
    },
    showCal: (id) => {
        dispatch(showCal(id));
    },
    updateCalculator: (id, data) => {
        dispatch(updateCalculator(id, data));
    }
})
  
  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewFormula));